import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enMessages from "../../messages/en.json";
import frMessages from "../../messages/fr.json";

export async function initI18n() {
    if (i18n.isInitialized) {
        return i18n;
    }

    await i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources: {
                en: { translation: enMessages },
                fr: { translation: frMessages },
            },
            fallbackLng: "en",
            supportedLngs: ["en", "fr"],
            interpolation: { escapeValue: false },
            detection: {
                order: ["cookie", "navigator"],
                caches: ["cookie"],
                cookieMinutes: 525600, // 1 year
                lookupCookie: "kn_lang",
            },
        });

    return i18n;
}

export default i18n;
